import { Link } from "react-router-dom";
import "./bottombar.css";
import { locations, siteMeta } from "../../data/siteContent";

export default function Bottombar() {
    return (
        <footer className="footer">
            <div className="footer__grid">
                <div>
                    <p className="footer__eyebrow">Vandaag Begin Ik</p>
                    <h2 className="footer__title">Persoonlijk, haalbaar en duurzaam leefstijladvies.</h2>
                    <p className="footer__text">
                        {siteMeta.practitioner} begeleidt cliënten in Breda met aandacht voor voeding,
                        beweging en ontspanning.
                    </p>
                </div>

                <div>
                    <p className="footer__eyebrow">Snel naar</p>
                    <div className="footer__links">
                        <Link to="/praktijk">Praktijk</Link>
                        <Link to="/consult">Consult</Link>
                        <Link to="/tips">Tips</Link>
                        <Link to="/adres">Locaties</Link>
                        <Link to="/contact">Contact</Link>
                    </div>
                </div>

                <div>
                    <p className="footer__eyebrow">Contact</p>
                    <a className="footer__contact" href={siteMeta.phoneHref}>
                        {siteMeta.phone}
                    </a>
                    <a className="footer__contact" href={siteMeta.emailHref}>
                        {siteMeta.email}
                    </a>
                    <p className="footer__text">Werkzaam op meerdere spreekuur locaties in Breda.</p>
                </div>
            </div>

            <div className="footer__locations">
                {locations.map((location) => (
                    <div key={location.street} className="footer__location">
                        <strong>{location.title}</strong>
                        <span>{location.street}, {location.city}</span>
                    </div>
                ))}
            </div>

            <div className="footer__bottom">
                <span>{siteMeta.siteUrl.replace("https://", "")}</span>
                <div className="footer__legal">
                    <a href="/AlgemeneVoorwaarden.pdf" target="_blank" rel="noreferrer">
                        Algemene voorwaarden
                    </a>
                    <a href="/Privacyverklaring.pdf" target="_blank" rel="noreferrer">
                        Privacyverklaring
                    </a>
                </div>
            </div>
        </footer>
    );
}
